import { DrippingHelper } from '../drippingHelper';
import { queryClient } from 'src/config/request';
import { contentListQueries } from 'src/modules/contentList/queries';
export class PageCacheUpdater {
    /**
     * Updates the cache for pages matching the given criteria.
     *
     * @param modules - An array of module IDs. Only pages belonging to these modules will be considered.
     * @param pages - An array of page IDs to update. Only pages with matching IDs will be updated.
     * @param data - Partial data to merge into each matching page.
     */
    static updateMatching({ modules, pages, data }) {
        queryClient.setQueriesData({
            queryKey: contentListQueries.getPages._def,
            exact: false
        }, (oldData) => oldData?.map((page) => pages.includes(page.id) || modules.includes(module.id) ? { ...page, ...data } : page));
    }
    static insertPage({ pageId, isUpdate, payload, isPublished }) {
        queryClient.setQueryData(contentListQueries.getPages(payload.page.moduleId).queryKey, (oldData) => {
            if (!oldData)
                return;
            const { page, mediaIdList } = payload;
            const drippingConfigs = isUpdate ? page.updatedDrippingConfigs?.saved : page.drippingConfigs;
            const { drippingConfig, drippingConfigsSize } = DrippingHelper.extractDrippingDataToList(drippingConfigs);
            const basePageData = {
                id: pageId,
                name: page.name,
                drippingConfig,
                drippingConfigsSize,
                published: isPublished,
                moduleId: page.moduleId,
                type: 'content',
                hasMedia: Boolean(mediaIdList.length)
            };
            if (isUpdate) {
                return oldData.map((page) => page.id === pageId
                    ? {
                        ...page,
                        ...basePageData,
                        pageOrder: page.pageOrder
                    }
                    : page);
            }
            const newPage = {
                ...basePageData,
                rates: [],
                avgRate: 0,
                totalComments: 0,
                webinarKey: null,
                webinarStartDate: null,
                pageOrder: (oldData[oldData.length - 1]?.pageOrder ?? 0) + 1
            };
            return [...oldData, newPage];
        });
    }
    static delete(pageIds, moduleId) {
        const filters = moduleId
            ? {
                queryKey: contentListQueries.getPages(moduleId).queryKey
            }
            : {
                queryKey: contentListQueries.getPages._def,
                exact: false
            };
        queryClient.setQueriesData(filters, (oldData) => oldData?.filter((page) => !pageIds.includes(page.id)));
    }
    static updatePublishStatus(moduleId, pageId, isPublished) {
        queryClient.setQueryData(contentListQueries.getPages(moduleId).queryKey, (oldData) => oldData?.map((page) => (page.id === pageId ? { ...page, published: isPublished } : page)));
    }
}
